
import Whowe from '../components/About/Whowe'
import SanGroups from '../components/About/SanGroups'
// import BuildFuture from '../components/About/BuildFuture'
import Whatwe from '../components/About/Whatwe'
import Aboutus from '../components/About/About'
import { SEO } from '../utils/SEO'

export default function AboutUs() {
    SEO({
        title: 'About SAN Technovation | IT, Embedded & IoT Solutions Company',

        description:
            'Learn about SAN Technovation, an innovative IT, Embedded, and IoT solutions company delivering software development, digital platforms, automation systems, web and mobile applications, UI/UX design, and engineering solutions for businesses.',

        keywords:
            'SAN Technovation, About SAN Technovation, IT Solutions Company, Technology Company, Software Development, Custom Software Development, Embedded Systems, Embedded Solutions, IoT Solutions, Industrial IoT, Web Development, Mobile App Development, UI UX Design, Automation Systems, Engineering Solutions, Digital Engineering, Enterprise Software, Digital Transformation',

        author: 'SAN Technovation',

        ogTitle:
            'About SAN Technovation | IT, Embedded & IoT Solutions Company',

        ogDescription:
            'Discover SAN Technovation, a technology company delivering software development, embedded systems, IoT solutions, automation, UI/UX design, and digital engineering services.',

        ogType: 'website',

        ogSiteName: 'SAN Technovation',

        canonical: 'https://www.santechnovation.com/about'
    })
    return (
        <main className="">
            <Aboutus />
            <Whowe />
            <SanGroups />
            <Whatwe />
            {/* <BuildFuture /> */}
            <section className="py-8 md:py-12 px-4 sm:px-6 lg:px-24 bg-[#F4F5F6]">
                <div className="mx-auto max-w-7xl">
                    <iframe title='Location'
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15651.120721257817!2d77.58333660000001!3d11.277562849999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba96d880618826d%3A0x7b06a1c794d65962!2sSAN%20TECHNOVATION%20PVT%20LTD!5e0!3m2!1sen!2sin!4v1771590086518!5m2!1sen!2sin"
                        width="100%"
                        height="450"
                        style={{ border: 0 }}
                        allowFullScreen
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                        className="rounded-xl"
                    />
                </div>
            </section>
        </main>
    )
}


